import { useEffect, useState } from 'react';
import { ActionGroup } from '@/components/BuildingTabs/DashboardActionGroup';

import { ActionItem } from '@urbanmix-tech/shared-js';

import { getActionItem } from '@/data';

export type TaskWidgetProps = {
  actionItemId: string;
};

export function TaskWidget(props: any) {
  const [actionItem, setActionItem] = useState<ActionItem | null>(null);
  const { actionItemId } = props.payload;
  const { onClickActionItem } = props;

  useEffect(() => {
    getActionItem(actionItemId).then((ai) => {
      setActionItem(ai);
    });
  }, [actionItemId]);

  return actionItem ? (
    <ActionGroup
      unitId={actionItem.unitId}
      category="notice"
      actionItems={[actionItem]}
      onClickActionItem={(e) => {
        console.log('Row Click propagation TaskWidget', e);
        onClickActionItem(actionItem.id);
      }}
    />
  ) : (
    <div>Loading...</div>
  );
}
